import React from 'react';
type Props = {
  children: React.ReactNode;
  onError: (message: string) => void;
};
type State = {
  failed: boolean;
};

/** Keeps a failing 3D canvas from unmounting the panels around it. */
export class SceneBoundary extends React.Component<Props, State> {
  state: State = {
    failed: false
  };
  static getDerivedStateFromError(): State {
    return {
      failed: true
    };
  }
  componentDidCatch(error: unknown) {
    this.props.onError(error instanceof Error ? error.message : String(error));
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}